/* ------------ -------------- ------------*/
/* ------------  Validate Form ------------*/
/* ------------ -------------- ------------*/

export default  (values) =>{

    const errors = {}

    if (!values.title) {
        errors.title = 'این فیلد ضروری است'
    }
    if (!values.code) {
        errors.code = 'این فیلد ضروری است'
    }

    return errors
};